import { FC, ReactNode, RefObject } from 'react';
import { useLocation } from 'react-router-dom';

import { RevertWebImageWrapper, WebImageWrapper, NewWebImageWrapper } from 'styles/common';


import WebImage from 'assets/home-page/web.webp';
import NewWebImage from 'assets/home-page/new-web.webp';
import RevertWebImage from 'assets/home-page/revert-web.webp';

type ShowWebs = 'none' | 'left' | 'right' | 'both';

import {
  HeroSectionContent,
  HeroSectionGradient,
  HeroSectionVideo,
  HeroSectionWrapper,
  LeftTriangle,
  RightTriangle,
} from './HeroSection.styles';
import { useIsDesktop } from 'hooks/useIsDesktop';
import { preventDefaultHandler } from 'helpers/preventDefaultHandler';

interface HeroSectionProps {
  background?: string;
  children: ReactNode;
  showWebs?: ShowWebs;
  isWebMobile?: boolean;
  bgImage?: string;
  bgVideo?: string;
  videoRef?: RefObject<HTMLVideoElement>;
  gradient?: string;
}

export const HeroSection: FC<HeroSectionProps> = ({
  background = '#000000',
  children,
  showWebs = 'none',
  isWebMobile = true,
  bgImage,
  bgVideo,
  videoRef,
  gradient,
}) => {
  const isDesktop = useIsDesktop();
  const location = useLocation();
  const isPlatformPage = location.pathname === '/platform';
  const isResourcesPage = location.pathname === '/resources';
  const shouldShowLeftWeb =
    (isWebMobile || isDesktop) && (showWebs === 'left' || showWebs === 'both');
  const shouldShowRightWeb =
    (isWebMobile || isDesktop) && (showWebs === 'right' || showWebs === 'both');

  return (
    <HeroSectionWrapper
      sx={{
        background,
        backgroundImage: bgVideo ? 'none' : `url(${bgImage ?? ''})`,
      }}
    >
      {bgVideo && (
        <HeroSectionVideo
          ref={videoRef}
          src={bgVideo}
          muted
          loop
          playsInline
          autoPlay
          onContextMenu={preventDefaultHandler}
        />
      )}

      {gradient && <HeroSectionGradient gradient={gradient} />}

      <HeroSectionContent>
        {shouldShowLeftWeb && isPlatformPage && (
          <NewWebImageWrapper sx={{ zIndex: -1 }}>
            <img src={NewWebImage} alt="web" />
          </NewWebImageWrapper>
        )}

        {shouldShowLeftWeb && isResourcesPage && (
          <WebImageWrapper>
            <img src={WebImage} alt="web" />
          </WebImageWrapper>
        )}

        {shouldShowRightWeb && (
          <RevertWebImageWrapper sx={{ zIndex: -1 }}>
            <img src={RevertWebImage} alt="revert-web" />
          </RevertWebImageWrapper>
        )}

        {children}
      </HeroSectionContent>

      <LeftTriangle />
      <RightTriangle />
    </HeroSectionWrapper>
  );
};
